<p-sidebar [(visible)]="visible" position="left" [fullScreen]="true" [baseZIndex]="10000">
  <ng-template pTemplate="headless">
    <div class="sidebar-container">
      <div class="sidebar-header">
        <img class="img-logo" src="assets/images/logo.png" alt="{{ 'MAP.LEGENDS.ALT_LOGO' | translate }}" >
        <p-button type="button" (click)="closeSidebar()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" size="large"></p-button>
      </div>
      <ng-container *ngIf="!showLegends"> 
        <app-layers (legendConsultClicked)="onLegendConsultClicked(true)"></app-layers> 
        <app-account></app-account>
      </ng-container> 
      <ng-container *ngIf="showLegends">
        <app-legends (legendConsultClicked)="onLegendConsultClicked(false)"></app-legends> 
      </ng-container>
      


    </div>
      
  </ng-template>

  </p-sidebar>
  